import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button } from "semantic-ui-react";
import PropTypes from "prop-types";

export default class NewButton extends Component {
  render() {
    const { text, to, style, ...otherProps } = this.props;

    return (
      <Button
        as={to ? Link : undefined}
        to={to}
        size="small"
        icon="plus"
        content={text}
        labelPosition="left"
        style={{
          backgroundColor: "#eb9b0f",
          color: "black",
          ...style,
        }}
        {...otherProps}
      />
    );
  }
}

NewButton.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  style: PropTypes.object,
};

NewButton.defaultProps = {
  text: "New",
  style: {},
};
